import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Button } from "../../../Common/UI/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";
import { ScheduleTable } from "./ScheduleListTable/ScheduleTableLogic";
import Add from "~icons/ic/baseline-add-circle";
import "./Style.scss";

interface IScheduleListViewProps {
  onClick: () => void;
}

// Responsible for rendering schedule list
export const SchedulingListView: React.FC<IScheduleListViewProps> = (props: IScheduleListViewProps) => {
  const { onClick } = props;
  const { t: translate } = useTranslation();

  return (
    <div className="ebt-extract-scheduling">
      <div className="ebt-extract-scheduling__add-btn">
        <Button
          data-testid="ebt-add-new-schedule"
          variant={ButtonVariantType.FILLED}
          onClick={onClick}
        >
          <Add title="add" />
          {translate("Button.AddNewSchedule")}
        </Button>
      </div>
      <ScheduleTable />
    </div>
  );
};
